import { Outlet, createRootRoute, useLocation } from '@tanstack/react-router'
import { TanStackRouterDevtoolsPanel } from '@tanstack/react-router-devtools'
import { TanstackDevtools } from '@tanstack/react-devtools'
import Header from '../components/header';
import CaptureComponent from '../components/CaptureComponent';
import { WebcamSourceConfigProvider } from '../contexts/WebcamSourceConfigContext';
import { GraphQLAndSWRAPIsProvider } from '@/contexts/graphql-and-swr-apis';
// import VersionFooter from '../components/VersionFooter';

export const Route = createRootRoute({
  component: RootComponent,
})

function RootComponent() {
  const location = useLocation()
  const isEmbed = location.pathname.startsWith('/embed/')

  return (
    <GraphQLAndSWRAPIsProvider>
      {!isEmbed && <Header />}
      <Outlet />
      {/* <VersionFooter /> */}
      {/* <TanstackDevtools
        config={{
          position: 'bottom-left',
        }}
        plugins={[
          {
            name: 'Tanstack Router',
            render: <TanStackRouterDevtoolsPanel />,
          },
        ]}
      /> */}
      </GraphQLAndSWRAPIsProvider>
  );
}
